import { render, staticRenderFns } from "./items.vue?vue&type=template&id=0d1541d0&"
import script from "./items.vue?vue&type=script&lang=ts&"
export * from "./items.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports